import type { Core } from '@pdftron/webviewer';
import { compareNumbers } from './mathUtils';

// export function dateToString(date: Date | null | undefined): string {
//     if (date == null || date == undefined) {
//         return '';
//     } else {
//         return date.toLocaleString();
//     }
// }

// // Regex for the Foxit date format: D:yyyyMMddhhmmssTZ.
// const regex = /(20\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
// const timeZoneReg = /(\+|-)(\d{2})'(\d{2})'/;

export const dateTimeFormat: Intl.DateTimeFormatOptions = {
    timeZone: 'Europe/Berlin',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
};

export const toGermanTimestring = (date: Date): string => {
    const dateString = date.toLocaleString('de-DE', {
        ...dateTimeFormat,
        timeZone: 'Europe/Berlin',
        timeZoneName: 'longOffset',
    });

    const [timestamp, timezone] = dateString.split('GMT');
    return timestamp + timezone.replace('GMT', '').replace(':', "'");
};

/**
 * de-DE: Dienstag, 29.03.2022
 * en-US: Tuesday, March 29, 2022
 */
export function toLocaleLongString(date: Date): string {
    return date.toLocaleDateString('de-DE', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });
}

export const dateToLocaleString = (date: Core.PDFNet.Date): string => {
    const utcHour = date.hour - date.UT_hour;
    const monthIndex = date.month - 1;
    const utcTimestamp = new Date(
        Date.UTC(date.year, monthIndex, date.day, utcHour, date.minute, date.second),
    );

    return utcTimestamp.toLocaleString(window.navigator.language, dateTimeFormat);
};

export function compareDates(a: Date | null, b: Date | null, invert: boolean): number {
    if (a !== null && b !== null) {
        return compareNumbers(a?.getTime(), b?.getTime(), invert);
    }

    return 0;
}

/**
 * example: "D:20250924111642+02'00'"
 */
export function parseXFDFDate(dateString: string): Date {
    const [dateTime, timezone] = dateString.split(/[ :+-]/).slice(1);

    const year = Number(dateTime.substring(0, 4));
    const month = Number(dateTime.substring(4, 6)) - 1;
    const day = Number(dateTime.substring(6, 8));
    const hours = Number(dateTime.substring(8, 10));
    const minutes = Number(dateTime.substring(10, 12));
    const seconds = Number(dateTime.substring(12, 14));

    const offsetSign = dateString.includes('+') ? 1 : -1;
    const offsetHours = Number(timezone.substring(0, 2));
    const offsetMinutes = Number(timezone.substring(3, 5));
    const offset = offsetHours * 60 + offsetMinutes;

    const date = new Date(Date.UTC(year, month, day, hours, minutes, seconds));
    date.setTime(date.getTime() - offset * offsetSign * 60000);

    return date;
}

/**
 * example: "D:20250924111642+02'00'"
 */
export function getCurrentXFDFDateString(): string {
    const dateTimeDE = new Date().toLocaleString('de-DE', {
        timeZone: 'Europe/Berlin',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZoneName: 'longOffset',
    });

    const [datePart, timePart, offsetPart] = dateTimeDE.split(/[ ,]/).filter(s => Boolean(s));

    // "24.09.2025" => "20250924"
    const date = datePart.split('.').reverse().join('');

    // "11:16:42" => "111642"
    const time = timePart.split(':').join('');

    // "GMT+02:00" => "+02'00'"
    const offset = offsetPart.substring(offsetPart.length - 6).replace(':', "'") + "'";

    return `D:${date}${time}${offset}`;
}
